import { api } from '../../lib/api';
import type { Contact, ContactInput } from '../../types/contact';

export async function listContacts(accountId?: string): Promise<Contact[]> {
  const q = accountId ? `?accountId=${encodeURIComponent(accountId)}` : '';
  const res = await api<{ contacts: Contact[] }>(`/api/contacts${q}`);
  return res.contacts;
}

export async function getContact(id: string): Promise<Contact> {
  const res = await api<{ contact: Contact }>(`/api/contacts/${id}`);
  return res.contact;
}

export async function createContact(input: ContactInput): Promise<Contact> {
  const res = await api<{ contact: Contact }>('/api/contacts', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return res.contact;
}

export async function updateContact(
  id: string,
  patch: Partial<ContactInput>,
): Promise<Contact> {
  const res = await api<{ contact: Contact }>(`/api/contacts/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return res.contact;
}

export async function softDeleteContact(id: string): Promise<void> {
  await api<{ ok: true }>(`/api/contacts/${id}`, { method: 'DELETE' });
}
